import { render, staticRenderFns } from "./HeroChapter.vue?vue&type=template&id=77d676e6&scoped=true&"
import script from "./HeroChapter.vue?vue&type=script&lang=js&"
export * from "./HeroChapter.vue?vue&type=script&lang=js&"
import style0 from "./HeroChapter.vue?vue&type=style&index=0&id=77d676e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d676e6",
  null
  
)

export default component.exports